import styled from 'styled-components';
import {Container} from 'react-bootstrap';

export const PageWrapper = styled.div`
`

export const NavSection = styled(Container)`
  /*padding: 0 15px;
  @media screen and (min-width: 768px) {
    padding: 0 40px;
  }*/
`

export const PageSection = styled.div`
  padding: 50px 0 100px;
  &.bg-blue{
    background-color: #EAF4FC;
  }
  & .findUs{
    margin: 60px 0 35px;
    @media screen and (min-width: 1024px) {
      margin: 65px 0 60px;
    }
  }
`

export const HeadContent = styled.div`
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  font-weight: 600;
  font-size: 22px;
  color: #808387;
  line-height: 200%;
`

export const AvatarContainer = styled.div`
  width: 100%;
  /*@media screen and (min-width: 576px) {
    width: 200px;
    height: 230px;
  }*/
  //border-radius: 10px;
  overflow: hidden;
  margin-bottom: 65px;
`

export const AvatarImg = styled.img`
  width: 100%;
  /*height: 150px;
  @media screen and (min-width: 576px) {
    height: 200px;
  }*/
  background-color: #ffffff;
  border-radius: 10px;
`

export const AvatarPlaceholder = styled.div`
  width: 100%;
  height: 150px;
  @media screen and (min-width: 576px) {
    height: 200px;
  }
  background-color: #ffffff;
  border-radius: 10px;
`

export const YouContainer = styled.div`
  background-color: #fff;
  border-radius: 10px;
  text-align: center;
  position: relative;
  display: flex;
  align-items: flex-end;
  justify-content: center;
  width: 100%;
  height: 150px;
  @media screen and (min-width: 576px) {
    height: 200px;
  }
`

export const HiringContainer = styled.div`
  position: relative;
  margin-top: 250px;
  padding: 120px 50px 50px;
  width: 100%;
  background: linear-gradient(180deg, rgba(255, 255, 255, 0.5) 0%, rgba(255, 255, 255, 0) 100%), rgba(234, 244, 252, 0.7);
  box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  border-radius: 20px;
  @media screen and (min-width: 576px) {
    padding: 50px;
  }
`

export const AvatarName = styled.div`
  text-align: center;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  padding: 5px 0;
  font-family: Manrope, Helvetica, "Helvetica Neue", sans-serif;
  color: #2c2b48;
`

export const Img = styled.img`
  max-width: 100%;
`

export const SittingImg = styled.img`
  position: absolute;
  right: 0;
  top: -150px;
`

export const JoinBtn = styled.a`
  display: inline-block;
  color: #3B3C3E;
  max-width: 162px;
  &:hover{
    text-decoration: none;
    box-shadow: -8.49px -8.49px 5px rgba(255, 255, 255, 0.33), 8.17px 8.17px 12px rgba(36, 38, 89, 0.1);
  }
`